import 'globals';

(function($, window) {
	var checkInterval = 500,
		// [width, height]
		size = [null, null],
		checkSizeChange = function() {
			var sizeCurrent = [$(window).width(), $(window).height()],
				sizeChanged = false;

			if (size[0] === null || sizeCurrent[0] != size[0]) {
				size[0] = sizeCurrent[0];
				sizeChanged = true;

				$(window).triggerHandler('widthChange');
			}
			if (size[1] === null || sizeCurrent[1] != size[1]) {
				size[1] = sizeCurrent[1];
				sizeChanged = true;

				$(window).triggerHandler('heightChange');
			}

			if (!sizeChanged) {
				bindResize();
			}
		},
		checkSizeChangeInterval = null,
		bindResize = function() {
			$(window).on('resize.sizeChange', function() {
				$(this).off('resize.sizeChange');

				if (checkSizeChangeInterval != null) {
					clearInterval(checkSizeChangeInterval);
				}

				checkSizeChange();
				checkSizeChangeInterval = setInterval(checkSizeChange, checkInterval);
			});
		};

	bindResize();
})(jQuery, window);
